import { Typography } from "antd";
import React, { memo } from "react";
import FileIcon from "../../assets/icons/file.svg";
import ModelStatusPendingIcon from "../../assets/icons/pendingIconGenerate.svg";
import './modelListItem.css';
import { Image } from "react-bootstrap";
import DateTime from "../DateTime/DateTime";

interface ModelListItemProps {
  id: string;
	name: string;
	dateTime: Date;
  isChecked: boolean;
  item: any;
  showCheckbox: boolean;
  onItemClick: (item: any) => void;
  onCheckboxClick: (item: any, isChecked: boolean) => void;
  icon?: any;
	isIconComponent?: boolean;
	dateTimeProps?: any;
  showPendingStatus?: boolean;
}

const ModelListItem = ({
  id,
	name,
	dateTime,
  isChecked,
  showCheckbox,
  item,
  onItemClick,
  onCheckboxClick,
  icon,
	isIconComponent=false,
	dateTimeProps={},
  showPendingStatus=false,
}: ModelListItemProps) => {
  return (
    <div className="model-wrapper-list col-md-4 col-lg-3 col-xl-2" key={id}>
      <button className="p-2 model-button-list position-relative">
        {showCheckbox && (
          <input
            type="checkbox"
            className="position-absolute model-checkbox"
            style={{
              top: "5px",
              right: "5px",
              opacity: showCheckbox ? 1 : 0,
            }}
            onChange={(e) => {
              e.stopPropagation();
              onCheckboxClick(item, e.target.checked);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            checked={isChecked}
          />
        )}
        <div className="text-center" onClick={() => onItemClick(item)}>
          <div className="position-relative d-inline-block">
						{(icon && isIconComponent) ? icon: <img src={FileIcon} alt="" className="model-icon-list" />}
            {showPendingStatus && (
              <Image
                src={ModelStatusPendingIcon}
                className="position-absolute pending-icon"
              />
            )}
          </div>
          <div className="text-center">
            <Typography.Text
              ellipsis
              title={name}
              className="model-card-name"
            >
							{name}
            </Typography.Text>
          </div>
          <div className="text-center">
            <Typography.Text className="created-time-text">
              Updated on{" "}
              <DateTime
                dateTime={dateTime}
                showTooltip
                tooltipProps={{ placement: "bottom" }}
								{...dateTimeProps}
              />
            </Typography.Text>
          </div>
        </div>
      </button>
    </div>
  );
};

export default memo(ModelListItem);
